const React = require('react');
const Emitter = require('utils/event-emitter');

const ToastContainer = React.createClass({
	render(){
		return (
			<div className='toast-container'>
				<div className='toast-body'>
					{this.props.children}
				</div>
			</div>
		);
	}

});

const Toast = React.createClass({
	
	hideToast(){
		service.removeToast(this.props.message);
	},

	render(){

		var alertClass = this.props.message.messageType || 'success';

		return (
			<div className={'alert alert-'+alertClass+' toast-message'} onClick={this.hideToast}>
				{this.props.message.text}
			</div>
		);
	}
});

var service = {

	TOAST_EVENT: 'toast',

	emitter: new Emitter(),

	messages: [],

	toast(message,messageType){
		
		var oMessage = {
			text: message,
			messageType: messageType || 'success'
		};

		service.messages.push(oMessage);
		service.emitter.emit(service.TOAST_EVENT);

		setTimeout(function(){
			service.removeToast(oMessage);			
		}, 5000);
		
	},

	removeToast(oMessage){
		service.messages = service.messages.filter(function(m){ return m !== oMessage});
		service.emitter.emit(service.TOAST_EVENT);
	},

	mixin: {
		
		componentDidMount() {
			service.emitter.addEventListener(service.TOAST_EVENT,this.refreshToasts);
		},

		componentWillUnmount(){
			service.emitter.removeEventListener(service.TOAST_EVENT,this.refreshToasts);
		},

		refreshToasts(){ 
			this.setState({}); 
		},

		renderToasts(){
			var items = service.messages.map(function(message,index){
				return <Toast key={index} message={message} />;
			});
			return <ToastContainer>{items}</ToastContainer>;
		}

	}

};

module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/utils/toast-service.js
 **/